// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12.75 4.33594V11.3359L5.75 4.33594V19.6644L12.75 12.6644V19.6644L20.4142 12.0002L12.75 4.33594Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-forward-filled')
export default class ForwardFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'forward-filled',
    }
  }
}
